<div class="questionContainer">
  <div class="titleContainer">
    <div class="title">
      {{ question.question_content }}
    </div>
  </div>
  <div class="contentContainer">
    <div class="answersContainer">
      @for (answer of answers; track answer; let i = $index) {
        <span class="answer" [class.dynamic]="answers[i].dynamic" [class.isFilled]="isFilled(i)" [class.bounce]="shouldBounce(i)" (click)="unselectChoice(i)">
          {{ answer.sentence }}
        </span>
      }
    </div>
    <div class="separator"></div>
    <div class="choicesContainer">
      @for (choice of possibleChoices; track choice; let i = $index) {
        <div class="choice" (click)="selectChoice(i)" [class.selected]="isSelected(choice)">
          {{ choice }}
        </div>
      }
    </div>
    <div class="refreshContainer">
      <div (click)="resetQuestion()" class="refreshButton">
        <i class="bi bi-arrow-clockwise"></i>
      </div>
    </div>
  </div>
</div>
